function fmtDate(s) {
  if (!s) return '—';
  try { return new Date(s).toLocaleDateString('en-SG', { day: 'numeric', month: 'long', year: 'numeric' }); }
  catch { return s; }
}

export default function StepReview({ data, onNext, onBack }) {
  const pos = data.pos?.filter(p => p.name?.trim()) || [];

  return (
    <div>
      <div className="card">
        <div className="card-title">Agreement summary — please review before generating</div>

        <div style={{ marginBottom: '1.25rem' }}>
          <p style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 500, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.3px' }}>
            Customer
          </p>
          <table className="preview-table">
            <tbody>
              <tr><td>Company name</td><td>{data.custName || '—'}</td></tr>
              <tr><td>UEN</td><td>{data.custUen || '—'}</td></tr>
              <tr><td>Signatory</td><td>{data.custSigName ? `${data.custSigName}${data.custSigTitle ? ` (${data.custSigTitle})` : ''}` : '—'}</td></tr>
              <tr><td>Email</td><td>{data.custEmail || '—'}</td></tr>
              <tr><td>Phone</td><td>{data.custPhone || '—'}</td></tr>
              <tr><td>Address</td><td style={{fontSize:12}}>{[data.billing?.street1, data.billing?.street2, data.billing?.city, data.billing?.zip, data.billing?.country].filter(Boolean).join(', ') || '—'}</td></tr>
            </tbody>
          </table>
        </div>

        <div style={{ marginBottom: '1.25rem' }}>
          <p style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 500, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.3px' }}>
            Agreement Terms
          </p>
          <table className="preview-table">
            <tbody>
              <tr><td>Product brand</td><td>Revitalash</td></tr>
              <tr><td>Start date</td><td>{fmtDate(data.startDate)}</td></tr>
              <tr><td>Duration</td><td>{data.duration || 12} months</td></tr>
              <tr><td>End date</td><td>{fmtDate(data.endDate)}</td></tr>
              <tr><td>Credit term</td><td>{data.creditTerm || 30} days</td></tr>
              <tr><td>Payment methods</td><td style={{ fontSize: 12 }}>{data.paymentMethod || '—'}</td></tr>
              <tr><td>Structural discount</td><td>{data.discount && data.discount !== '0' ? `${data.discount}%` : 'None'}</td></tr>
              <tr><td>GST registered</td><td>{data.gstRegistered ? 'Yes' : 'No'}</td></tr>
              <tr><td>Portal access</td><td>Yes — tied to customer account</td></tr>
            </tbody>
          </table>
        </div>

        {pos.length > 0 && (
          <div>
            <p style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 500, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.3px' }}>
              Points of Sale
            </p>
            <table className="preview-table">
              <tbody>
                {pos.map((p, i) => (
                  <tr key={i}><td>{p.name}</td><td>{p.addr || '—'}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="alert alert-info">
        <span className="alert-icon">ℹ</span>
        <div className="alert-body">
          <p>Review all details carefully. The PDF will be generated with exactly this information. You can go back to make changes.</p>
        </div>
      </div>

      <div className="row between">
        <button className="btn btn-ghost" onClick={onBack}>← Edit</button>
        <button className="btn btn-primary" onClick={onNext}>Generate document →</button>
      </div>
    </div>
  );
}
